<template>
  <div>
    <b-container fluid class="fp-container bg-light-grey">
      <Tiedot />
    </b-container>
    <b-container class="fp-container bg-white">
      <b-row>
        <b-col>
          <h1>Tutustu runkojärjestelmiin</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-tabs content-class="bg-white">
            <b-card no-body>
              <b-tabs card class="rakenne-content">
                <b-tab v-for="(content,slug) in contentNodes" :title="content.title" :key="slug" @click="fetchTab(slug)">
                  <template v-slot:title>
                    <b-spinner v-if="content.loading" type="border" small></b-spinner> {{content.title}}
                  </template>
                  <b-container v-if="!content.loading">
                    <b-row>
                      <b-col md="4" class="text-left">
                        <p v-for="(item,index) in content.nodes" :title="item.title" :key="index" class="m-0 mb-2"><a href="#" @click="showContent(item, $event)" :class="item.title==selectedTitle?'itemlink itemlink-active':'itemlink'">{{ item.title }}</a></p>
                      </b-col>
                      <b-col md="8" class="content-node">
                        <h2 class="text-left mb-3">{{selectedTitle}}</h2>
                        <div v-html="selectedContent"></div>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable */
import Tiedot from '../components/Tiedot'
import jarjestelmat from '../data/jarjestelmat.js'

export default {
  name: 'solveltuvat_jarjestelmat',
  components: {Tiedot},
  data () {
    return {
      selectedTitle: '',
      selectedContent: '',
      contentNodes: {
        ranka:  {
          title: 'Rankarakenteet',
          loading: false,
          nodes: []
        },
        puulevy:  {
          title: 'Massiivipuulevyrakenteet',
          loading: false,
          nodes: []
        },
        pilari:  {
          title: 'Pilari-palkkirakenteet',
          loading: false,
          nodes: []
        },
        hirsi: {
          title: 'Hirsirakenteet',
          loading: false,
          nodes: []
        },
      }
    }
  },
  created: function () {
    this.fetchTab('ranka')
  },
  methods: {
    fetchTab(slug) {
      if (this.contentNodes[slug].nodes.length < 2) {
        this.fetchPage(slug, data => {
          if (data.length > 0) {
            this.filterContent(data[0].content.rendered, this.contentNodes[slug].nodes)
            this.showContent(this.contentNodes[slug].nodes[0])         }
        })
      }
      this.showContent(this.contentNodes[slug].nodes[0])
    },
    filterContent (htmlString, contentNodes) {
      var virtual = new DOMParser().parseFromString(htmlString, "text/html")
      var nodes = virtual.firstChild.childNodes[1].childNodes;
      var contentTitle = ''
      var contentHtml = ''
      nodes.forEach(node => {
        if(node.nodeName === 'H2'){
          if (contentTitle !== '') {
              contentHtml += '<div class="clearfix"></div>'
            contentNodes.push( {title: contentTitle, content: contentHtml} )
          }
          contentTitle = node.innerText
          contentHtml = '';
        } else if (node.outerHTML){
          contentHtml += node.outerHTML
        }
      })

      contentNodes.push( {title: contentTitle, content: contentHtml} )
    },
    fetchPage (slug, callback) {
      this.contentNodes[slug].loading = true
      const params = {
        'filter[name]': slug,
        rest_route: '/wp/v2/pages'
      }
      this.axios
        .get('https://epuu.fi/', { params })
        .then(response => {
          this.contentNodes[slug].loading = false
          callback(response.data)
        })
        .catch(error => {
          this.contentNodes[slug].loading = false
          this.title = 'Latausvirhe'
          console.error(error)
        })
    },
    getItems (row) {
      return jarjestelmat.map(item => {
        return {
          row: item.row,
          value: item[row]
        }
      })
    },
    showContent (item, e) {
      this.selectedTitle = item.title
      this.selectedContent = item.content
      if (e) {
        e.preventDefault()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .rakenne-content .card-header{
    padding-left: 20px;
  }

  table.b-table td:first-child {
    width: 120px;
  }

  .nav-link.active{
    font-weight: bold;
  }

  table.b-table td {
    min-width: 220px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/Jarjestelmat.vue